import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

const requiredEnvVars = [
  'VUE_APP_GRAPHQL_URL',
  'VUE_APP_GOOGLE_FONT_API_KEY'
]
const missingEnvVars = requiredEnvVars.filter((name) => !process.env[name])
if (missingEnvVars.length > 0) {
  throw new Error(`Missing required environment variable(s): ${missingEnvVars.join(', ')}`)
}

Vue.use(VueAnalytics, {
  id: 'UA-53948108-4',
  autoTracking: {
    screenview: true
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
